import { render, staticRenderFns } from "./MobileFavorite.vue?vue&type=template&id=58961ad6&scoped=true&"
import script from "./MobileFavorite.vue?vue&type=script&lang=js&"
export * from "./MobileFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58961ad6",
  null
  
)

export default component.exports